import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { NotificationsDispatch } from './reducers/notifications'
import notificationReducer, {
  NotificationsState,
  initialNotificationsState,
} from './reducers/notifications'

type Context = [NotificationsState, NotificationsDispatch]

const { context: NotificationsContext, hook: useNotifications } = createContext<Context>()

const NotificationsProvider = ({ children }: React.PropsWithChildren) => {
  const memoizedReducer = useCallback(notificationReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialNotificationsState())

  return (
    <NotificationsContext.Provider value={[state, dispatch]}>
      {children}
    </NotificationsContext.Provider>
  )
}

export { NotificationsProvider, useNotifications as useNotifications }
